$(function() {

    /* Run functions when page loads
    ==================================================================================================== */
    $(document).ready(function () {
        // Make Shogun content accessible
        accessibleShogun();

        // Update cart attriibutes
        if ( !$('body').hasClass('template-cart') ) {
            // Update cart attributes for Complete the Look
            updateCartAttributesOnLoad('cart-complete-look-items', 'complete_the_look');

            // Update cart attributes for Quick Buy
            updateCartAttributesOnLoad('quick-buy-items', 'quick_buy');
        }

        // Track PDP for Complete the Look
        if ( $('body').hasClass('template-product') ) {
            trackCompleteTheLookPDP();
        }

        // Verify cart page and update for removals
        if ( $('body').hasClass('template-cart') ) {
            verifyCartQuickBuy();
        }
    });


    /* Update window size when resized
    ==================================================================================================== */
    $(window).on('resize', function() {
        document.documentElement.style.setProperty('--window-width', document.documentElement.clientWidth + 'px');
        document.documentElement.style.setProperty('--window-height', document.documentElement.clientHeight + 'px');
    });


    /* Close header drop-down menus
    ==================================================================================================== */
    // Close with ESC key (Prestige code for this doesn't work)
    $(document).on('keyup', function(e) {
        if (e.keyCode === 27) {
            $('.header__menu-disclosure[open]').removeAttr('open');
            $('.header__menu-disclosure[aria-expanded="true"]').attr('aria-expanded','false');
        }
    });

    // Close with close button
    $('.mega-menu .close').on('click', function(e) {
        $(this).parents('.header__menu-disclosure').removeAttr('open');
        $(this).parents('.header__menu-disclosure').attr('aria-expanded','false');
    });


    /* Attach listener for footer email signup form submission
    ==================================================================================================== */
    $(document).on('click', '[data-footer-subscribe-submit]', function() {
        submitNewsletterRegistration();
    });


    /* Back to Top Button
    ==================================================================================================== */
    $(window).on('scroll', function(e) {
        // Enable if back to top button detected
        if ( $('#back-to-top').length ) {
            // Enable on collection page (PLP), product page (PDP), and content page
            if ( $('.template-collection').length || $('.template-product').length || $('.template-page').length ) {
                var scrollPos = $(document).scrollTop();
                if (scrollPos >= 500) {
                    if (!$('#back-to-top').hasClass('visible')) {
                        $('#back-to-top').addClass('active').delay(50).queue(function() {
                            $(this).addClass('visible').dequeue();
                        });
                    }
                } else {
                    $('#back-to-top').removeClass('active visible')
                }
            }
        }
    });
    $(document).on('click', '#back-to-top', function() {
        $('html, body').animate({ scrollTop: 0 }, 'fast');
    });


    /* ESC Size Chart Accessibility
    ==================================================================================================== */
    // Trigger when size chart link is clicked
    $(document).on('click', 'div[data-app="eastsideco_sizeGuides"] a', function() {
        // Move popup to after size chart link
        $(this).parent().append( $('.esc-size-guide--popup') );

        // ARIA tagging
        $('.esc-size-guide--popup').attr('role','dialog').attr('aria-label','Size Chart Popup').attr('aria-modal','true').attr('tabindex','-1');
        /*
        $('.esc-size-guide--popup').attr('aria-label','Size Chart Popup');
        $('.esc-size-guide--popup').attr('aria-modal','true');
        $('.esc-size-guide--popup').attr('tabindex','-1');
        */
        $('.esc-size-guide--popup .modal_background').attr('aria-hidden','true');

        // Semantic close button
        $('.esc-size-guide--popup .modal_close').replaceWith('<button type="button" class="modal_close" title="Close Size Chart" aria-label="Close Size Chart">✖</button>');

        // Make popup focusable and move focus to title
        //if ( $('.esc-size-guide--popup .size-chart-popup-note').length == 0 ) {
        //  $('.esc-size-guide--popup .modal_container').prepend('<div class="size-chart-popup-note u-visually-hidden" role="note" tabindex="-1">Popup Size Chart</div>');
        //}
        //$('.esc-size-guide--popup .size-chart-popup-note').focus();

        // Move focus on modal dialog
        $('.esc-size-guide--popup').focus();

        // Trap focus
        trapFocus( $('.esc-size-guide--popup') );
    });
    $(document).on('click', '.esc-size-guide--popup .modal_close', function() {
        // Hide popup
        $('.esc-size-guide--popup').hide();
        // Focus back on size chart link
        $('div[data-app="eastsideco_sizeGuides"] a').focus();
    });


    /* Track Quick Buy and "Complete the Look" (Cart) Purchases
    ==================================================================================================== */

    /* Save cart line item product ID to local storage
       Triggers on click of:
        * Quick Buy modal "Add to Bag" button
        * Quick Buy button on product card for products with a single variant
        * Complete the Look "Add to Bag" button for products with a single variant
        * "Add to Bag" on PDP after click through from modal
    */
    $(document).on('click', 'quick-buy-modal buy-buttons button[type="submit"], .product-card__quick-add-button[type="submit"], .cart-drawer__complementary-products button[type="submit"], .shopify-product-form button.complete-the-look', function() {
        var cart_item_product_id = false;

        // Get line item product ID in Quick Buy modal or from form for products with a single variant
        var quick_buy_modal = $(this).closest('quick-buy-modal');
        if ( quick_buy_modal.length ) {
            cart_item_product_id = quick_buy_modal.find('input[name="product-id"]').val();
        } else {
            cart_item_product_id = $(this).closest('.shopify-product-form').find('input[name="product-id"]').val();
        }
        
        // Update local storage array
        if ( cart_item_product_id.length ) {
            if ( quick_buy_modal.data('section') == 'cart-sell-complete-look' || $(this).closest('.cart-drawer__complementary-products').length || $(this).hasClass('complete-the-look') ) {
                updateLocalStorageItems('cart-complete-look-items', cart_item_product_id);
            } else {
                updateLocalStorageItems('quick-buy-items', cart_item_product_id);
            }
        }
    });

    // When cart change custom event fires, verify that added products are in cart
    $(document).on('cart:change', verifyCartQuickBuy);

    // Add line item property for tracking Quick Buy and "Complete the Look" purchases
    $(document).on('quickbuy:loaded', function(event) {
        // Allowed quick buy sections
        var quick_buy_sections = ['cart-sell-complete-look','collection','search','complementary-products','related-products','recently-viewed'];

        // Get current quick buy section
        var quick_buy_section = $('#quick-buy-modal-content').closest('quick-buy-modal').data('section');

        // If is allowed section, add hidden form input for line item property
        if ( $.inArray(quick_buy_section, quick_buy_sections) !== -1 ) {
            var hidden_input = $('<input>').attr('type', 'hidden').attr('name', 'properties[_source]');
            switch (quick_buy_section) {
                case 'cart-sell-complete-look':
                    hidden_input.attr('value', 'Complete the Look');
                    break;
                case 'collection':
                    hidden_input.attr('value', 'Quick Buy (Collection)');
                    break;
                case 'search':
                    hidden_input.attr('value', 'Quick Buy (Search)');
                    break;
                case 'complementary-products':
                    hidden_input.attr('value', 'Quick Buy (Complementary Products)');
                    break;
                case 'related-products':
                    hidden_input.attr('value', 'Quick Buy (Related Products)');
                    break;
                case 'recently-viewed':
                    hidden_input.attr('value', 'Quick Buy (Recently Viewed Products)');
                    break;
            }
            $('#quick-buy-modal-content .shopify-product-form').append(hidden_input);
        }

        // If it's a Complete the Look Quick Buy, add tracking parameter to product page links
        if ( quick_buy_section == 'cart-sell-complete-look' ) {
            // Add parameter to product title link
            var title_link = $('.quick-buy-modal__info-wrapper .product-title a');
            if ( title_link.length ) {
                var new_title_url = addParamToURL(title_link.attr('href'), 'qbsrc', 'ctl');
                title_link.attr('href', new_title_url);
            }

            // Add parameter to view more link
            var more_link = $('.quick-buy-modal__info-wrapper a.quick-buy-modal__view-more');
            if ( more_link.length ) {
                var new_more_url = addParamToURL(more_link.attr('href'), 'qbsrc', 'ctl');
                more_link.attr('href', new_more_url);
            }
        }
    });

});


/* Add Line Item Property on PDP for Complete the Look
==================================================================================================== */
/*
Notes: If a user opens a Complete the Look quick buy modal, then clicks the "View Details" link to the
product page, then adds the product to cart, we want to still attribute this to Complete the Look.
*/
function trackCompleteTheLookPDP() {
    var query = window.location.search;
    var params = new URLSearchParams(query);
    var source = params.get('qbsrc');
    if ( source == 'ctl' ) {
        // Add line item property as hidden input in product form
        var hidden_input = $('<input>').attr('type', 'hidden').attr('name', 'properties[_source]').attr('value', 'Complete the Look');
        $('.shopify-section--main-product .product-info .shopify-product-form').append(hidden_input);

        // Add class to product form submit button, so it can be used to trigger other functions
        $('.shopify-section--main-product .product-info .shopify-product-form button[type="submit"]').addClass('complete-the-look');
    }
}


/* Verify Cart and Update Attributes
==================================================================================================== */
function verifyCartQuickBuy() {
    // Get the array from local storage
    var cart_complete_look_items = localStorage.getItem('cart-complete-look-items');
    var quick_buy_items = localStorage.getItem('quick-buy-items');

    // If the local storage arrays don't exist, do not proceed
    if ( !cart_complete_look_items && !quick_buy_items ) {
        return false;
    }

    // Parse the stored array (which is stored as a string)
    cart_complete_look_items = JSON.parse(cart_complete_look_items);
    quick_buy_items = JSON.parse(quick_buy_items);

    // Verify whether "Complete the Look" or Quick Buy products are in cart
    var cart_products = [];
    $.ajax({
        url: '/cart.js',
        dataType: 'json',
        success: function(cart) {
            var cartItems = cart.items;
            // If cart has products
            if ( cartItems.length > 0 ) {

                // Build array of cart item product ID's
                $.each(cartItems, function(index, item) {
                    cart_products.push(item.product_id);
                    // console.log('Cart Item Product ID: ' + item.product_id);
                });
                // console.log('Cart Products: ' + cart_products);

                // Update cart attributes
                updateCartAttributes(cart_products, cart_complete_look_items, 'cart-complete-look-items', 'complete_the_look');
                updateCartAttributes(cart_products, quick_buy_items, 'quick-buy-items', 'quick_buy');

            } else {
                // Remove local storage arrays if cart is empty
                localStorage.removeItem('cart-complete-look-items');
                localStorage.removeItem('quick-buy-items');
            }
        }
    });
}


/* Update Cart Attributes (On Page Load)
==================================================================================================== */
/*
Notes: This ensures the cart attribute matches data stored in local storage, whether on the cart drawer or cart page.
*/
function updateCartAttributesOnLoad(local_storage_key, cart_attribute_name) {
    // Get the array from local storage
    var local_storage_items = localStorage.getItem(local_storage_key);

    // If the array doesn't exist, empty cart attributes and stop
    if (!local_storage_items) {
        updateCartAttributeInputs(cart_attribute_name, false);
        return false;
    }

    // Parse the stored array (which is stored as a string)
    local_storage_items = JSON.parse(local_storage_items);

    // Update cart attributes
    if ( local_storage_items.length < 1 ) {
        updateCartAttributeInputs(cart_attribute_name, false);
    } else {
        updateCartAttributeInputs(cart_attribute_name, true, local_storage_items.join(','));
    }
}


/* Update Cart Page Attributes (On Page Load)
==================================================================================================== */
/*
Notes: Update cart attributes on cart page when items are removed. The cart page is only accessible
from checkout and line items cannot be added, only removed.
*/
function updateCartPage(local_storage_key, cart_attribute_name) {
    // Get the array from local storage
    var local_storage_items = localStorage.getItem(local_storage_key);

    // If the array doesn't exist, empty cart attributes and stop
    if (!local_storage_items) {
        updateCartAttributeInputs(cart_attribute_name, false);
        return false;
    }

    // Parse the stored array (which is stored as a string)
    local_storage_items = JSON.parse(local_storage_items);

    // Update cart attributes
    if ( local_storage_items.length < 1 ) {
        updateCartAttributeInputs(cart_attribute_name, false);
    } else {
        updateCartAttributeInputs(cart_attribute_name, true, local_storage_items.join(','));
    }
}


/* Update Local Storage Array of Quick Buy Items
==================================================================================================== */
/*
Notes: Check if the current item already exists in local storage array, and if it does not, add it to the end of local storage array
Parameters:
    * local_storage_key: Key of the local storage data so we can update it
    * cart_item_product_id: Product ID of the item in cart
*/
function updateLocalStorageItems(local_storage_key, cart_item_product_id) {
    if ( local_storage_key && cart_item_product_id ) {
        // Retrieve local storage array, and if it does not, create an empty array
        var local_storage_items = JSON.parse(
            localStorage.getItem(local_storage_key) || '[]'
        );

        // If cart item is not in local storage array
        if (!local_storage_items.includes(cart_item_product_id)) {
            // Push product ID to array as number because this is how cart.js stores ID's
            local_storage_items.push(Number(cart_item_product_id));
            // console.log(local_storage_key + ' Local Storage Products: ' + local_storage_items);
        }

        // Save the updated items list into the local storage
        try {
            localStorage.setItem(
                local_storage_key,
                JSON.stringify(local_storage_items)
            );
        } catch (error) {
            console.log('Function updateLocalStorageItems() unable to update local storage for: ' + local_storage_key);
        }
    }
}


/* Update Cart Attributes for Quick Buy Items
==================================================================================================== */
/*
Notes: Make sure local storage array is up to date by checking that local storage array items are in cart.
       If not in cart, remove them from local storage array.
       Update cart attributes with local storage array.
Parameters:
    * cart_products: An array of product ID's of items in the cart
    * local_storage_items: Parsed JSON string of product ID's from local storage
    * local_storage_key: Key of the local storage data so we can update it
    * cart_attribute_name: Used to update the right cart attributes
*/
function updateCartAttributes(cart_products, local_storage_items, local_storage_key, cart_attribute_name) {
    if ( cart_products && local_storage_items && local_storage_key && cart_attribute_name ) {
        // Look through each item in local storage array and check if it's in the cart
        for (const item of local_storage_items) {
            if ( $.inArray(item, cart_products) !== -1 ) {
                // If current item is in cart, do nothing
                // console.log('Cart contains this ' + cart_attribute_name + ' product: ' + item);
            } else {
                // If current items is not in cart, remove from array
                var index = local_storage_items.indexOf(item);
                if (index > -1) {
                    local_storage_items.splice(index, 1);
                    try {
                        localStorage.setItem(
                            local_storage_key,
                            JSON.stringify(local_storage_items)
                        );
                    } catch (error) {
                        console.log('Function updateCartAttributes() unable to update local storage for key: ' + local_storage_key);
                    }
                    // console.log('Removed from ' + cart_attribute_name + ' items: ' + item);
                }
            }
        }
        // Update cart attributes
        if ( local_storage_items.length < 1 ) {
            updateCartAttributeInputs(cart_attribute_name, false);
        } else {
            updateCartAttributeInputs(cart_attribute_name, true, local_storage_items.join(','));
        }
    }
}


/* Update Cart Attribute Inputs (For Quick Buy and Complete the Look)
==================================================================================================== */
function updateCartAttributeInputs(attribute_name, contains_products, value) {
    if ( attribute_name ) {
        if ( contains_products && value ) {
            // If cart contains matching products, update attributes
            $('input[name="attributes[' + attribute_name + ']"]').val('true');
            $('input[name="attributes[' + attribute_name + '_products]"]').val(value);
        } else {
            // If cart doesn't contain matching products, empty out the attribute values
            $('input[name="attributes[' + attribute_name + ']"]').val('');
            $('input[name="attributes[' + attribute_name + '_products]"]').val('');
        }
    }
}


/* Add Parameter to URL
==================================================================================================== */
function addParamToURL(url, param, value) {
    if ( url && param && value ) {
        if ( url.indexOf('?') !== -1 ) {
            url = url + '&' + param + '=' + value;
        } else {
            url = url + '?' + param + '=' + value;
        }
        return url;
    } else {
        return false;
    }
}


/* Validate email address formatting
==================================================================================================== */
function validateEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
};


/* Submit footer subscribe form via AJAX
==================================================================================================== */
function submitNewsletterRegistration() {
    // If blank, do nothing
    if (!$('#footer-subscribe-email').length) {
        return;
    }

    var err = '';

    // Reset error message display
    $('[data-footer-subscribe-error]').empty();
    $('[data-footer-subscribe]').removeClass('has-error');

    // Error message for invalid email address
    if (!validateEmail($('#footer-subscribe-email').val())) {
        err = 'Please enter a valid email.';
    }

    // Error message for blank email address
    if ($('#footer-subscribe-email').val() === '') {
        err = 'Please enter your email.';
    }

    // Submit form
    if (err === '') {
        // Submit and display success message
        $('#footer-subscribe').submit();
        $('[data-footer-subscribe]').removeClass('has-error');
        $('[data-footer-subscribe]').addClass('success');
    } else {
        // Display error message
        $('[data-footer-subscribe-error]').text(err);
        $('[data-footer-subscribe]').addClass('has-error');
    }
}


/* Improve Accessibility of Shogun Button Module (When Link Opens In New Window)
==================================================================================================== */
function accessibleShogunButton() {
    // If button module link found
    if ( $('.shg-btn-wrapper a.shg-btn').length > 0 ) {
        // Cycle through each link
        $('.shg-btn-wrapper a.shg-btn').each(function() {
            // If link opens in new window
            if ( $(this).attr('target') == '_blank' ) {
                if ( $(this).attr('title') == null ) {
                    // If there is no title attribute, add it with new window text
                    $(this).attr('title', 'Opens in a new window');
                } else if ( $(this).attr('title').toLowerCase().indexOf('new window') < 0  ) {
                    // If there is a title attribute, append new window text to the end
                    $(this).attr('title', $(this).attr('title') + ' - Opens in a new window');
                }
            }
        });
    }
}


/* Improve accessibility of Shogun Accordion module
==================================================================================================== */
function accessibleShogunAccordion() {
    // If accordion found
    if ( $('.shogun-accordion').length > 0 ) {
        $('.shogun-accordion').each(function() {
            // Get the accordion button element
            if ( $(this).find('.shogun-accordion-icon').length > 0 ) {
                var accordion_button = '.shogun-accordion-icon span';
            } else if ( $(this).find('.shogun-accordion-heading').length > 0 ) {
                var accordion_button = '.shogun-accordion-heading';
            } else {
                return false;
            }

            // Add ARIA attributes to each accordion button
            $(this).find(accordion_button).attr('role','button').attr('tabindex','0').attr('aria-haspopup','true');
            
            // If the accordion button has a .shogun-accordion parent with .shogun-accordion-active class, set aria-expanded to true, otherwise set to false
            $(this).find(accordion_button).each(function() {
                if ( $(this).closest('.shogun-accordion').hasClass('shogun-accordion-active') ) {
                    $(this).attr('aria-label','Close section').attr('aria-expanded','true');
                } else {
                    $(this).attr('aria-label','Open section').attr('aria-expanded','false');
                }
            });$

            // Toggle aria-expanded attribute as appropriate
            $(this).find(accordion_button).click(function() {
                if ( $(this).attr('aria-expanded') == 'false' ) {
                    // Set this one to true
                    $(this).attr('aria-label','Close section').attr('aria-expanded', 'true');
                } else {
                    // Close so set to false
                    $(this).attr('aria-label','Open section').attr('aria-expanded', 'false');
                }
            });

            // If the accordion button is a span inside .shogun-accordion-icon,
            // then clicking on the .shogun-accordion-heading should not trigger any events
            // and should instead trigger a click on the accordion button
            if ( accordion_button == '.shogun-accordion-icon span' ) {
                // If .shogun-accordion-heading is clicked, do nothing and do not trigger any attached events
                // and trigger click on the accordion button instead without bubbling back to the heading.
                $(this).find('.shogun-accordion-heading').on('click', function(e) {
                    $(this).closest('.shogun-accordion').find(accordion_button).first().triggerHandler('click');
                });
            }

            // Simulate click if Enter or Space key is used on keyboard
            $(this).find(accordion_button).on('keydown', function(e) {
                if (e.key === 'Enter' || e.key === ' ') this.click();
            });

            // Observe for changes to each .shogun-accordion to see if it has the .shogun-accordion-active class, and update aria-expanded attribute accordingly
            var observer = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                    if ( mutation.target.classList.contains('shogun-accordion-active') ) {
                        $(mutation.target).find(accordion_button).attr('aria-label','Close section').attr('aria-expanded', 'true');
                    } else {
                        $(mutation.target).find(accordion_button).attr('aria-label','Open section').attr('aria-expanded', 'false');
                    }
                });
            });
            observer.observe(this, { attributes: true, attributeFilter: ['class'] });
        });
    }
}


/* Improve accessibility of Shogun Add to Cart button
==================================================================================================== */
function accessibleShogunAddToCart() {
    // If add to cart button found
    if ( $('a.rca-add-to-cart-submit').length > 0 ) {
        // Cycle through each link
        $('a.rca-add-to-cart-submit').each(function() {
            // Add attributes
            $(this).attr('role','button').attr('tabindex','0').attr('aria-label',$(this).text());
        });
    }
}


/* Wrapper for Shogun Accessibility Functions (Run on Page Load)
==================================================================================================== */
function accessibleShogun() {
    accessibleShogunButton();
    accessibleShogunAccordion();
    accessibleShogunAddToCart();
}


/* Trap Focus in Modal for Accessibility
==================================================================================================== */
function trapFocus(elem) {
    // Find tabbable elements
    var tabbable = elem.find('a, button').filter(':visible');

    // Set up first and last tabbable elements
    var firstTabbable = tabbable.first();
    var lastTabbable = tabbable.last();

    // Redirect last tab to first element
    lastTabbable.on('keydown', function (e) {
        if ((e.which === 9 && !e.shiftKey)) {
            e.preventDefault();
            firstTabbable.focus();
        }
    });

    // Redirect first shift+tab to last element
    firstTabbable.on('keydown', function (e) {
        if ((e.which === 9 && e.shiftKey)) {
            e.preventDefault();
            lastTabbable.focus();
        }
    });
}